import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=2ec3d519&scoped=true"
import script from "./RightSideBar.vue?vue&type=script&lang=ts"
export * from "./RightSideBar.vue?vue&type=script&lang=ts"
import style0 from "./RightSideBar.vue?vue&type=style&index=0&id=2ec3d519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3d519",
  null
  
)

export default component.exports